export const getSearchResult = state => state.search.result;
